import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { JournalHeader } from '@/components/journal/journal-header'
import { JournalHero } from '@/components/journal/journal-hero'
import { JournalGrid } from '@/components/journal/journal-grid'

const JournalIndex: FC = (): ReactNode => {
    return (
        <Layout theme='light' className='bg-paper text-ink'>
            <Seo
                title='Journal'
                description='Notes from the studio on process, craft, and the work behind the work.'
            />

            <JournalHeader />
            <JournalHero />
            <JournalGrid />
        </Layout>
    )
}

export default JournalIndex
